<template>
  <div class="about Tracking">

    <section id="servicios" class="secciones seccion-blanca formulario">        
      <div class="container">
        <h1>Libro de Reclamaciones</h1>
        <br>

       <form data-toggle="validator" role="form" action="" @submit.prevent="registrar_consulta">
         
          <div class="row">
            <div class="col-sm-12">
              <div class="row">
                  <div class="col-sm-6">

                    <h4>Identificación del consumidor reclamante</h4>
                    <br>

                    <div class="form-group">
                      <span class="ico-form ico-form-nombre"><input type="text" class="form-control ico-form-space" v-model="client_name" placeholder="Nombre Completo *" required pattern=".*[^ ].*" title="Ingrese su nombre completo." maxlength="400"></span>
                    </div>

                    <div class="form-group">
                      <span class="ico-form ico-form-email"><input type="text" class="form-control ico-form-space" v-model="client_home" placeholder="Domicilio *" required pattern=".*[^ ].*" title="Ingrese su domicilio" maxlength="400"></span>
                    </div>

                    <div class="form-group">
                      <span class="ico-form ico-form-nombre"><input type="text" class="form-control ico-form-space" v-model="dni_ce" placeholder="DNI/CE *" required title="Ingrese su documento de identidad." maxlength="8" pattern="[0-9]{8}"></span>
                    </div>

                    <div class="form-group">
                      <span class="ico-form ico-form-nombre"><input type="text" class="form-control ico-form-space" v-model="client_phone" placeholder="Teléfono *" required pattern="[0-9()+][0-9() -]+" title="Ingrese su Teléfono." maxlength="9"></span>
                    </div>

                    <div class="form-group">
                      <span class="ico-form ico-form-nombre"><input type="email" class="form-control ico-form-space" v-model="email_client" placeholder="Correo electrónico *" required title="Ingrese su correo electrónico." maxlength="500"></span>
                    </div>

                </div>
                <div class="col-sm-6">

                    <h4>Identificación del bien contratado</h4>
                    <br>

                    <div class="form-group">
                     <select class="form-control ico-form-space" v-model="type_service" id="basicSelect" value="Seleccione Tipo de Bien *" required>
                          <option disabled value="">Seleccione Tipo de Bien *</option>
                          <option value="PRODUCTO">Producto</option>
                          <option value="SERVICIO">Servicio</option>
                        </select>
                    </div>

                    <div class="form-group">
                      <span class="ico-form ico-form-nombre"><input type="number" min="0.00" max="10000.00" step="0.01"  class="form-control ico-form-space" v-model="claim_amount" placeholder="Monto Reclamado *" required  title="Ingrese el monto reclamado." maxlength="9"></span>
                    </div>

                    <div class="form-group">
                      <span class="ico-form ico-form-nombre"><input type="text" class="form-control ico-form-space" v-model="service_description" placeholder="Descripción *" required pattern=".*[^ ].*" title="Ingrese descripción del bien." maxlength="600"></span>
                    </div>

                </div>
             </div>
           </div>
           <div class="col-sm-12">
             <div class="row">
               <div class="col-sm-12">

                    <h4>Detalle de la reclamación y pedido del consumidor</h4>
                    <br>

                    <div class="form-group">
                      <select class="form-control ico-form-space" v-model="claim_type" id="basicSelect" value="Seleccione Tipo de Reclamación *" required>
                          <option disabled value="">Seleccione Tipo de Reclamación *</option>
                          <option value="RECLAMO">Reclamo</option>
                          <option value="QUEJA">Queja</option>
                      </select>
                    </div>

                    <div class="form-group">
                      <textarea class="form-control" style="height: 248px;" rows="8" v-model="claim_detail" placeholder="Ingrese el detalle de su reclamación *" maxlength="1500" required></textarea>
                    </div>

                    <div class="form-group">
                      <textarea class="form-control" style="height: 248px;" rows="8" v-model="claim_request" placeholder="Ingrese el detalle de su pedido *" maxlength="1500" required></textarea>
                    </div>

                </div>
                <div class="col-sm-12">

                    <h4>Menor de edad</h4>
                    <br>

                    
                    <div class="form-group">
                      <span class="ico-form ico-form-nombre"> 
                        
                        <input type="checkbox" id="checkbox" class="contact-inline" v-model="under_age"> Soy menor de edad </span>
                    </div>

                    <template v-if="under_age">

                      <div class="form-group">
                        <span class="ico-form ico-form-nombre"><input type="text" class="form-control ico-form-space" v-model="parent_name" placeholder="Nombre del padre/madre *" required pattern=".*[^ ].*" title="Ingrese su nombre completo del Padre/Madre." maxlength="400"></span>
                      </div>

                      <div class="form-group">
                        <span class="ico-form ico-form-email"><input type="text" class="form-control ico-form-space" v-model="parent_dni_ce" placeholder="DNI/CE *" required title="Ingrese el DNI/CE del padre." maxlength="8" pattern="[0-9]{8}"></span>
                      </div>

                      <div class="form-group">
                        <span class="ico-form ico-form-nombre"><input type="text" class="form-control ico-form-space" v-model="parent_phone" placeholder="Teléfono*" required pattern="[0-9()+][0-9() -]+" title="Ingrese el teléfono del padre." maxlength="9"></span>
                      </div>

                      <div class="form-group">
                        <span class="ico-form ico-form-nombre"><input type="email" class="form-control ico-form-space" v-model="parent_email" placeholder="Correo electrónico *" required title="Ingrese el correo electrónico del padre." maxlength="500"></span>
                      </div>

                    </template>

                </div>
             </div>
           </div>
            
         </div>
         

        
          
          <div class="col-xs-12 text-center">
            <div class="mensaje-obligatorio">* Los campos marcados con asterisco son obligatorios.</div>
            

            
          </div>

          <template v-if="mensaje !=''">
            <div class="col-xs-12 text-center">
              <div :class="[(mensaje === '') ? 'd-none' : 'alert alert-success']" role="alert"><button type="button" class="close" data-dismiss="alert" @click="ocultar()">&times;</button><strong>{{ mensaje }}</strong></div>
            </div>
          </template>
          <template v-if="mensaje_error != ''">
            <div class="col-xs-12 text-center">
              <div :class="[(mensaje_error === '') ? 'd-none' : 'alert alert-danger']" role="alert"><button type="button" class="close" data-dismiss="alert" @click="ocultar()">&times;</button><strong>{{ mensaje_error }}</strong></div>
            </div>
          </template>
          <template v-if="loading_form != false">
            <div class="col-xs-12 text-center">
            <div class="progress">
              <div class="progress-bar progress-bar-striped active" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
            </div>
            </div>
          </template>
          &nbsp;

          

          <div class="col-xs-12 text-center  mt-2">
            <button type="submit" class="btn btn-lg btn-primary" >Enviar Reclamo</button>
          </div>

          

        </form>
       

        <br>
        <br>

        
        <template v-if="reclamo_realizado">
          <button class="btn btn-secondary" @click="exportPDF"><i class="fa fa-print"></i> Imprimir Consolidado de Reclamo</button>
        </template> 

      </div>
    </section>

    <TwoModules></TwoModules>
    <Instagram></Instagram>

  </div>

</template>

<script>
import TwoModules from "@/components/products/TwoModules.vue";
import Instagram from "@/components/products/Instagram.vue";
import axios from "axios";
import {config_settings} from '@/config.js';
import _ from "lodash";
import { errorToaster } from '@/components/shared/service/ErrorHandler';
//import jsPDF from 'jspdf';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';

//HTTP ERROR STATUS
  const NOT_FOUND = 404;
  const BAD_REQUEST = 400;
  const UNAUTHORIZED = 401;
  const INTERNAL_SERVER_ERROR = 500;

  axios.interceptors.response.use(function (response) { return response; }, 
  function (error) {
    
    if(error.message === 'Network Error'){
      toastr.error("No se puede conectar con el servidor. Verifique su conexión a internet",
                       "ERROR",
                       {"iconClass": 'customer-danger'});
    }
    else if(error.response.status === UNAUTHORIZED){
      if(error.response.data.message === "Access is denied"){
         toastr.error("Usted no tiene los provilegios para acceder a esta sección",
                       "ERROR",
                       {"iconClass": 'customer-danger'});
      }
      else {
        return Promise.reject(error);
      }
    }
    else {
      return Promise.reject(error);
    }
});

export default {
  components: {
    TwoModules,
    Instagram
  },
  data() {
    return {
      imgPreUrl : config_settings.PHOTO_SERVER_URL+'/',
      cod_sub_sec: 6,
      nom_sub_sec_es: '',
      nom_sub_sec_en: '',
      internal_name_es: '',
      internal_name_en: '',
      desc_sub_section_es: '',
      desc_sub_section_en: '',
      section: '',
      url_1st_image: 'products/empty-img',
      url_2nd_image: 'products/empty-img',
      url_3rd_image: 'products/empty-img',
      url_4th_image: 'products/empty-img',
      url_5th_image: 'products/empty-img',
      type_1st_image: 'image',
      type_2nd_image: 'image',
      type_3rd_image: 'image',
      type_4th_image: 'image',
      type_5th_image: 'image',
      text1_es: '',
      text1_en: '',
      text2_es: '',
      text2_en: '',
      text3_es: '',
      text3_en: '',
      orientation: '',
      url_es: '',
      url_en: '',
      order_sub_section: '',
      id_position_menu: '',
      url_video: '',
      type: '',
      loading_form: false,
      mensaje_error: "",
      mensaje:"",

      

      claim_id: "",
      client_name: "",
      client_home: "",
      dni_ce: "",
      client_phone: "",
      email_client: "",
      type_service: "",
      claim_amount: "",
      service_description: "",
      claim_type: "",
      claim_detail: "",
      claim_request: "",
      under_age: false,
      parent_name: "",
      parent_dni_ce: "",
      parent_phone: "",
      parent_email: "",
      fecreg: "",
      detalle_reclamo_pdf: [],

      reclamo_realizado: false
    }
  },
  
  methods: {
   

    exportPDF() {
      var vm = this
      var  todos = this.detalle_reclamo_pdf;
      var columns = [
        {title: "Campo", dataKey: "title"},
        {title: "Valor Ingresado", dataKey: "description"}
      ];
      var doc = new jsPDF('p', 'pt');
      doc.text('Consolidado de Reclamo', 40, 40);
      doc.autoTable(columns, todos, {
        margin: {top: 60},
      });
      doc.save('Detalle-de-reclamo.pdf');
    },
  
    registrar_consulta() {

      

        this.loading_form = true
        if(this.parent_phone==""){
          this.parent_phone = 0
        }
        
        
        var json_data = {

            client_name: this.client_name,
            client_home: this.client_home,
            dni_ce: this.dni_ce,
            client_phone: this.client_phone,
            email_client: this.email_client,
            type_service: this.type_service,
            claim_amount: this.claim_amount,
            service_description: this.service_description,
            claim_type: this.claim_type,
            claim_detail: this.claim_detail,
            claim_request: this.claim_request,
            under_age: this.under_age,
            parent_name: this.parent_name,
            parent_dni_ce: this.parent_dni_ce,
            parent_phone: this.parent_phone,
            parent_email: this.parent_email
          
        }

       
        
        axios({
          method: 'post',
          url: config_settings.RESOURCE_SERVER_URL+'/POST/claims',
          data: json_data,
        })
        .then(response => {
          var texto_respuesta = response.data.details;
          console.log(texto_respuesta);
          var codigo = texto_respuesta.replace('The claim was created. id:','');
          //var fechayhora = moment(new Date()).local().format('YYYY-MM-DDTHH:mm');
          this.mensaje = "¡Su reclamo ha sido enviado exitosamente!"
          this.mensaje_error = ""
          this.detalle_reclamo_pdf = [
            {title: 'ID de reclamo', description: codigo},
           {title: 'Nombre de Cliente', description: this.client_name},
            {title: 'Domicilio del Cliente', description: this.client_home},
            {title: 'DNI/CE del cliente', description: this.dni_ce},
            {title: 'Email del cliente', description: this.email_client},
            {title: 'Tipo de Bien', description: this.type_service},
            {title: 'Monto del reclamo', description: this.claim_amount},
            {title: 'Descripción del servicio', description: this.service_description},
            {title: 'Tipo de Reclamo', description: this.claim_type},
            {title: 'Detalle del Reclamo', description: this.claim_detail},
            {title: 'Solicitud', description: this.claim_request},
            {title: 'Mejor de edad', description: this.under_age? "SI": "NO"},
            {title: 'Nombre del padre', description: this.parent_name == ""? "-" : this.parent_name},
            {title: 'DNI/CE del padre', description: this.parent_dni_ce == ""? "-" : this.parent_dni_ce},
            {title: 'Teléfono del padre', description: this.parent_phone == ""? "-" : this.parent_phone},
            {title: 'E-mail del padre', description: this.parent_email == ""? "-" : this.parent_email}

          ];
          this.reset();
          this.loading_form = false
          this.reclamo_realizado = true
          //this.scroll_inicio()
        })
        .catch(error => {
          this.mensaje = ""
          this.mensaje_error = "Hubo un error al momento de enviar su reclamo. Inténtelo nuevamente."
          this.reclamo_realizado = false
        
          //this.reset();
          this.loading_form = false
        })
    },

    ocultar() {
      this.mensaje = ""
      this.mensaje_error = ""
    },

    reset() {
      
      this.claim_id = "";
      this.client_name = "";
      this.client_home = "";
      this.dni_ce = "";
      this.client_phone = "";
      this.email_client = "";
      this.type_service = "";
      this.claim_amount = "";
      this.service_description = "";
      this.claim_type = "";
      this.claim_detail = "";
      this.claim_request = "";
      this.under_age = false;
      this.parent_name = "";
      this.parent_dni_ce = "";
      this.parent_phone = "";
      this.parent_email = "";
    
    },

    scroll_inicio(){
      window.scrollTo(0,0);
    }

  }, 

  created() {
    this.scroll_inicio();
  }
};
</script>

<style lang="scss" src="./Tracking.scss"></style>
